module.exports = __webpack_public_path__ + "static/img/ZW.fd5c960.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/ZW.png
// module id = xX+w
// module chunks = 34